// extracted by mini-css-extract-plugin
export default {"messenger":"Messenger_messenger__-yaYZ","composeArea":"Messenger_composeArea__grdbE"};